export const contexts = {
  login: 'login',
  authentication: 'authentication',
  dashboard: 'dashboard',
  advertisers: 'advertisers',
  addAdvertiser: 'addAdvertiser',
  campaigns: 'campaigns',
  addCampaign: 'addCampaign',
  adverts: 'adverts',
  addAdvert: 'addAdvert',
  notFound: 'notFound',
};

export const contextToPageNameMap = {
  login: 'Login',
  authentication: 'Authentication',
  dashboard: 'Dashboard',
  advertisers: 'Advertisers',
  addAdvertiser: 'Add Advertiser',
  campaigns: 'Campaigns',
  addCampaign: 'Add Campaign',
  adverts: 'Adverts',
  addAdvert: 'Add Advert',
  notFound: 'Not Found',
};
